import log from 'uix/logging'

export const tree = {
  tabs: {
    qa: {
      tabGroup: 'overview',
      datatype: [0, 1, 3],
      parts: ['TreeQA'],
      acl: 'g:admin',
      order: 50,
    },
    states: {
      tabGroup: 'overview',
      datatype: [1],
      parts: ['TreeStates'],
      acl: 'g:admin',
      order: 51,
    },
  },
}
